import {
  Box,
  TableRow,
  Paper,
  TableContainer,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { useListNotificationTemplates } from "../../../clients/graphql/pages/notification-queries";

interface NotificationTemplate {
  notificationTemplateKey: number;
  type: string;
  deliveryMethod: string;
  subject: string;
  body: string;
  createdAt: Date;
}

export const NotificationsPage: React.FC = () => {
  const navigate = useNavigate();
  const { loading, error, data } = useListNotificationTemplates();

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">
          Error loading notification templates: {error.message}
        </Typography>
      </Box>
    );
  }

  console.log(data);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4">Notification Templates</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() =>
              navigate("/developer/notifications/custom-campaigns")
            }
          >
            View Custom Campaigns
          </Button>
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Key</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Delivery Method</TableCell>
              <TableCell>Subject</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.listNotificationTemplates?.map(
              (template: NotificationTemplate) => (
                <TableRow
                  key={template.notificationTemplateKey}
                  sx={{ "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" } }}
                >
                  <TableCell>
                    <Link
                      to={`/developer/notifications/${template.notificationTemplateKey}`}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "block",
                        width: "100%",
                        cursor: "pointer",
                      }}
                    >
                      {template.notificationTemplateKey}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/developer/notifications/${template.notificationTemplateKey}`}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "block",
                        width: "100%",
                        cursor: "pointer",
                      }}
                    >
                      {template.type}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/developer/notifications/${template.notificationTemplateKey}`}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "block",
                        width: "100%",
                        cursor: "pointer",
                      }}
                    >
                      {template.deliveryMethod}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/developer/notifications/${template.notificationTemplateKey}`}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "block",
                        width: "100%",
                        cursor: "pointer",
                      }}
                    >
                      {template.subject}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        navigate(
                          `/developer/notifications/templates/${template.notificationTemplateKey}/${template.type}/campaigns`
                        )
                      }
                    >
                      View Campaigns
                    </Button>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
